<template>
  <base-dialog
    :action="onAction"
    :action-name="'Set Trial End Date'"
    :close="onClose"
    :title="'Trial Period'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-container>
        <v-row justify="center">
          <v-date-picker v-model="picker" />
        </v-row>
      </v-container>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { readableDateToUnix, unixToReadableDate } from "../../services/util.service"

/**
 * Trial period must be less than two years (730 days)
 */
export default {
  components: { BaseDialog },
  props: {
    initUnix: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      picker: this.initUnix ? unixToReadableDate(this.initUnix, 'YYYY-MM-DD') : null
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    async onAction() {
      this.$emit('action', readableDateToUnix(this.picker))
    }
  }
}
</script>
